<template>
  <div class="product-info-box">
    <div v-for="(infoData, index) in listForm" :key="index">
      <div style="margin-top: 10px">
        供应商：{{ infoData.supplierName }}
        <b v-if="infoData.isFormal && infoData.isFormal === '1'" style="color: #f00;">(正在引入评估中的供应商)</b>
      </div>
      <el-row
        class="product-info"
        v-for="(item, ind) in infoData.list"
        :key="ind"
      >
        <!-- left -->
        <el-col
          :span="2"
          style="padding-left: 10px; color: #999; word-break: break-all"
          >
          寻样单{{ item.code || item.$index }}：
        </el-col>
        <el-col :span="10" class="product-info-left">
          <ApplySampleLeft
            ref="ProductInfo"
            :listData="item"
            :isDisabled="isDisabled"
          />
        </el-col>

        <!-- right -->
        <el-col :span="12">
          <div class="product-info-right">
            <div class="product-info-header">给采购留言:</div>
            <el-form
              class="product-info-form"
              ref="productInfoForm"
              :model="item"
              :inline="true"
              inline-message
              label-width="110px"
              size="mini"
              :rules="rules"
            >
              <el-form-item label="用途" prop="purpose">
                <el-input
                  v-if="isInput"
                  style="width: 200px"
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="item.purpose"
                  :row="2"
                  maxlength="100"
                  size="mini"
                  :disabled="isDisabled"
                  show-word-limit
                />
                <span v-else style="word-break: break-all;">{{ item.purpose }}</span>
              </el-form-item>
              <el-form-item label="特殊备注" prop="specialRemark">
                <el-input
                  v-if="isInput"
                  style="width: 200px"
                  type="textarea"
                  :rows="2"
                  placeholder="1.如果有特殊打样要求,请备注;2.如果样品不是寄给采购,请备注"
                  v-model="item.specialRemark"
                  maxlength="100"
                  size="mini"
                  :disabled="isDisabled"
                  show-word-limit
                />
                <span v-else style="word-break: break-all;">{{ item.specialRemark }}</span>
              </el-form-item>
              <el-form-item label="需求人员" prop="demandStaffName">
                <el-input
                  v-if="isInput"
                  placeholder="请输入内容"
                  disabled
                  size="mini"
                  v-model="item.demandStaffName"
                />
                <span v-else>{{ item.demandStaffName }}</span>
              </el-form-item>
              <el-form-item label="需求品牌" prop="demandBrand">
                <DictSelect
                  v-if="isInput"
                  type="cml_brand"
                  :value="String(item.demandBrand)"
                  :disabled="isDemandBrand"
                  @change-emit="value => (item.demandBrand = value)"
                />
                <span v-else>{{ item.demandBrandName }}</span>
              </el-form-item>
              <el-form-item label="要求到样时间" prop="askArrivalTime">
                <el-date-picker
                  v-if="isInput"
                  v-model="item.askArrivalTime"
                  type="datetime"
                  size="mini"
                  :picker-options="expireTimeOption"
                  :disabled="isDisabled"
                  placeholder="选择时间"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
                <span v-else>{{ item.askArrivalTime }}</span>
              </el-form-item>
              <el-form-item label="采购审核" prop="purchaserCheck">
                <el-select
                  v-if="isInput"
                  v-model="item.purchaserCheck"
                  clearable
                  filterable
                  size="mini"
                  placeholder="请选择"
                  :disabled="isDisabled"
                  popper-append-to-body
                >
                  <el-option
                    v-for="purchaser in purchaserCheckData"
                    :key="purchaser.account"
                    :value="purchaser.id"
                    :label="purchaser.loginName"
                  ></el-option>
                </el-select>
                <span v-else>{{ item.purchaserCheckName }}</span>
              </el-form-item>
              <el-form-item label="上级领导审批" prop="leadApproval" v-if="item.sampleType === 'RAW_MATERIAL'">
                <el-select v-if="isInput" v-model="item.leadApproval">
                  <el-option
                    v-for="user in leaderList"
                    :key="user.loginName"
                    :label="user.name"
                    :value="user.loginName"
                  ></el-option>
                </el-select>
                <span v-else>{{ item.leadApprovalName }}</span>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col v-if="flattenArr().length > 1 && index === 0 && ind === 0" :span="24" class="fill-btn">
          <el-divider content-position="center">
            根据第一个样品信息
            <el-button
              @click="fillContentBtn"
              >自动填充样品信息</el-button
            >
          </el-divider>
        </el-col>
      </el-row>
    </div>

    <div class="bill-btns">
      <el-button
        v-if="!isDisabled"
        type="primary"
        @click="saveBtn"
        :loading="saveLoading"
        >提交样品申请</el-button
      >
    </div>

    <!-- 批量操作后的弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="resultDialogVisible"
      :append-to-body="true"
    >
      <ResultDialog
        :dialogResult="dialogResult"
        :tableDataField="'failResultList'"
        :tableLable="'产品名称'"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="dialogResultClose"
          size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ApplySampleLeft from '@/components/ApplySampleLeft';
import ResultDialog from '@/components/ResultDialog';
import DictSelect from '@/components/DictSelect';
import dayjs from 'dayjs';
export default {
  name: 'Sample',
  components: { ApplySampleLeft, ResultDialog, DictSelect },
  props: {
    listData: {
      type: Object,
      default() {
        return {};
      },
    },
    isInput: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isDemandBrand: {
      type: Boolean,
      default: false,
    },
  },
  data: vm => ({
    listForm: [],
    backName: {},
    saveLoading: false,
    userInfo: {},
    dialogResult: {},
    resultDialogVisible: false,
    infoData: vm.listData,
    rules: {
      purpose: [{ required: true, message: '请填写用途', trigger: 'blur' }],
      demandStaffName: [
        { required: true, message: '请填写需求人员', trigger: 'blur' },
      ],
      demandBrand: [
        { required: true, message: '请选择需求品牌', trigger: 'change' },
      ],
      purchaserCheck: [
        { required: true, message: '请选择采购审核', trigger: 'change' },
      ],
      leadApproval: [
        { required: true, message: '请选择上级领导审批', trigger: 'change' },
      ]
    },
    purchaserCheckData: [],
    expireTimeOption: {
      disabledDate: (time) => {
        return time.getTime() < Date.now() - 8.64e7;
      },
    },
    leaderList: []
  }),
  watch: {
    listData: {
      handler(val) {
        if(!val.list) return false
        this.getDetail(val.list[0].id)
        // return (this.listForm = [val]);
      },
      immediate: true,
    },
  },
  mounted() {
    const params = {
      customerId: '0'
    };
    this.$http.setting.getUserListBuyer(params).then(res => {
      this.purchaserCheckData = res.data;
    });
    this.getUser();
  },
  methods: {
    getUser() {
      this.$http.leadApprovalConfig
        .userList({})
        .then(result => {
          this.leaderList = result.data;
        })
    },
    // 获取详情
    getDetail(id) {
      if(!id) return;
      this.$http.sample
        .getOrderDetail(id)
        .then(result => {
          this.listForm = [{
            supplierName: result.data.supplierName,
            list: [result.data],
          }];
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    // 展开数据添加index
    flattenArr() {
      let arr = this.listForm.reduce((prev, cur) => {
        cur.list && cur.list.map(el => {
          prev.push(el);
          return prev;
        })
        return prev;
      }, []);
      arr.map((item, index) => {
        item.$index = index+1;
        return item;
      });
      return arr;
    },
    setListForm(val) {
      const { id, name } = this.$store.getters.userSelf.user;
      const { brand } = this.$store.getters.userSupplier;
      // 去索样
      const forPurchaserRemark = {
        purpose: '',
        specialRemark: '',
        demandStaff: id,
        demandStaffName: name,
        demandBrand: brand ? brand : '',
        askArrivalTime: dayjs().add(3, 'day').format('YYYY-MM-DD HH:mm:ss'),
        purchaserCheck: '',
        leadApproval: ''
      };

      this.listForm = val.map(item => {
        item.list = item.list.map(el => {
          return { ...el, ...forPurchaserRemark };
        });
        return item;
      });
      this.flattenArr();
      this.clearProductInfoForm();
    },
    // 清空form表单
    clearProductInfoForm() {
      this.$nextTick(() => {
        this.$refs.productInfoForm.map(el => {
          el.resetFields();
        });
      });
    },
    clearProductInfoValidate() {
      this.$nextTick(() => {
        this.$refs.productInfoForm.map(el => {
          el.clearValidate();
        });
      });
    },
    // 校验form表单
    checkFormValid() {
      let formValid = []; // 正确数据
      this.$refs.productInfoForm.map(item => {
        item.validate(valid => {
          formValid.push(valid)
        });
      });
      return formValid.every(Boolean);
    },
    saveBtn() {
      // form校验
      if (!this.checkFormValid()) {
        return;
      }
      const params = this.listForm.reduce((prev, cur) => {
        cur.list.map(el => {
          prev.push(el);
        });
        return prev;
      }, []);
      // 到样时间校验
      const errArr1 = params.filter(item => dayjs(dayjs().format('YYYY-MM-DD HH:mm:ss')).diff(dayjs(item.askArrivalTime)) > 0)
      if(errArr1.length > 0) {
        this.$message.error(`产品名称【${errArr1[0].productName}】的要求到样时间不能早于当前时间`);
        return;
      }

      const url = params[0].code ? 'updateOrderList' : 'batchCreateOrder';
      const paramsData = params[0].code ? params[0] : params;

      this.saveLoading = true;
      this.$http.sample[url](paramsData)
        .then(result => {
          if (JSON.stringify(result.data) == '{}' || result.data.failNum === 0) {
            this.$message.success('提交样品申请成功');
            this.$emit('on-success');
          } else {
            this.dialogResult = result.data;
            this.resultDialogVisible = true;
          }
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    dialogResultClose() {
      this.resultDialogVisible = false;
      this.$emit('submit-error');
    },
    // 自动填充样品信息
    fillContentBtn() {
      const firstItem = this.flattenArr()[0];
      this.flattenArr().map((item, index) => {
        if(index > 0) {
          item.purpose = firstItem.purpose;
          item.specialRemark = firstItem.specialRemark;
          item.demandBrand = firstItem.demandBrand;
          item.askArrivalTime = firstItem.askArrivalTime;
          item.purchaserCheck = firstItem.purchaserCheck;
        }
        return item;
      });
      this.clearProductInfoValidate();
    }
  },
};
</script>

<style lang="less" scoped>
.product-info-box {
  padding: 10px 10px 40px 10px;
  overflow: auto;
  // height: calc(100vh - 230px);
  .bill-btns {
    position: absolute;
    left: 50%;
    z-index: 10000;
    transform: translateX(-50%);
    bottom: 20px;
    text-align: center;
    margin-top: 20px;
  }
}
.product-info {
  display: flex;
  margin-top: 15px;
  font-size: 14px;
  flex-wrap: wrap; 
  .product-info-left {
    flex: 12;
    background: #f3fbfe;
    padding: 0 10px;
  }
  .product-info-right {
    flex: 12;
    background: #f7f7f7;
    padding: 0 10px;
  }
  .product-info-header {
    line-height: 24px;
  }
}
.product-info-form {
  .el-form-item {
    width: calc(50% - 10px);
    margin-bottom: 5px;
    /deep/.el-form-item__content {
      width: calc(100% - 110px) !important;
      .el-textarea .el-input__count {
        background: transparent;
        bottom: 0;
      }
    }
  }
}
.fill-btn {
  margin-top: 10px;
  .el-divider__text {
    margin-left: 120px;
    font-size: 12px;
    color: #AB0033;
  }
}
</style>
